import type { MessagingGetChatRoomById200LastMessageBasicInfoAllOf } from './messagingGetChatRoomById200LastMessageBasicInfoAllOf';
import type { MessagingGetChatRoomById200LastMessageBasicInfoAllOfTwo } from './messagingGetChatRoomById200LastMessageBasicInfoAllOfTwo';

export type MessagingGetChatRoomById200LastMessageBasicInfo = MessagingGetChatRoomById200LastMessageBasicInfoAllOf & MessagingGetChatRoomById200LastMessageBasicInfoAllOfTwo;
